"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCriticalPageInfo = getCriticalPageInfo;
const PAGE_MATCHERS = [
    // Exact matches from CRITICAL_PAGES
    { test: (pathname) => pathname === '/', name: 'homepage' },
    { test: (pathname) => pathname === '/art/', name: 'art' },
    { test: (pathname) => pathname === '/print/', name: 'print' },
    { test: (pathname) => pathname === '/all', name: 'browse-all' },
    { test: (pathname) => pathname === '/prints', name: 'browse-prints' },
    { test: (pathname) => pathname === '/paintings', name: 'browse-paintings' },
    { test: (pathname) => pathname === '/sculpture', name: 'browse-sculpture' },
    { test: (pathname) => pathname === '/photography', name: 'browse-photography' },
    { test: (pathname) => pathname === '/drawings', name: 'browse-drawings' },
    { test: (pathname) => pathname === '/collage', name: 'browse-collage' },
    { test: (pathname) => pathname === '/printmaking', name: 'browse-printmaking' },
    { test: (pathname) => pathname === '/mixed-media', name: 'browse-mixed-media' },
    { test: (pathname) => pathname === '/installation', name: 'browse-installation' },
    { test: (pathname) => pathname === '/digital', name: 'browse-digital' },
    { test: (pathname) => pathname === '/authentication', name: 'authentication' },
    { test: (pathname) => pathname === '/cart', name: 'cart' },
    { test: (pathname) => pathname === '/checkout', name: 'checkout' },
    { test: (pathname) => pathname === '/checkout/confirmation', name: 'checkout-confirmation' },
    { test: (pathname) => pathname === '/giftcard', name: 'giftcard' },
    { test: (pathname) => pathname === '/offer/', name: 'make-an-offer' },
    { test: (pathname) => pathname === '/accounts/offers', name: 'account-offers' },
    { test: (pathname) => pathname === '/studio/sales', name: 'studio-sales' },
    // Dynamic routes with REGEX patterns (from original implementation)
    {
        test: (pathname) => /^\/art\/.*\/view$/.test(pathname),
        name: 'product-detail-art',
    },
    {
        test: (pathname) => /^\/print\/.*\/view$/.test(pathname),
        name: 'product-detail-print',
    },
    {
        test: (pathname) => /^\/offer\/P\d+-U\d+-A\d+-T\d+/.test(pathname),
        name: (pathname) => pathname.includes('confirmation') ? 'mao-confirmation' : 'mao-checkout',
    },
    {
        test: (pathname) => /^\/accounts\/sale-confirmation\/\d+/.test(pathname),
        name: 'sale-confirmation',
    },
    { test: (pathname) => pathname === '/testpage', name: 'testpage' },
];
function getCriticalPageInfo(pathname) {
    if (!pathname)
        return null;
    const matcher = PAGE_MATCHERS.find((m) => m.test(pathname));
    if (!matcher)
        return null;
    const name = matcher.name;
    return typeof name === 'function' ? name(pathname) : name;
}
